import styled from 'styled-components'
import { remCalculator } from '../../../../helpers/theming/utilities'

const Wrapper = styled.div`
  background-color: ${(props) => props.theme.color.monochrome.white};
  display: flex;
  flex-direction: column;
  height: 100%;
  width: 100%;
  padding: ${(props) => remCalculator(props.theme.size.spacing.lg)} 0;
  padding-right: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  position: relative;
`
const ImageContainer = styled.a`
  position: relative;
  min-width: 100px;
  height: 100px;
  padding: 80% 0 0;
  display: block;

  @media screen and (min-width: ${(props) => props.theme.size.breakpoint['min-width'].md}) {
    margin-bottom: 10px;
    min-height: 200px;
    width: 100%;
    height: 100%;
    padding: 100% 0 0;
  }

  img {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    object-fit: contain;
    width: 100%;
    height: 100%;
    display: block;
    max-width: 100%;
    max-height: 100%;
  }
`

const BadgeContainer = styled.div`
  height: 25px;
  margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  img {
    height: 24px;
  }
`

const BodyCopy = styled.div`
  margin-bottom: ${(props) => remCalculator(props.theme.size.spacing.lg)};
  color: ${(props) => props.theme.color.monochrome.dark};

  li {
    margin-left: 10px;
    line-height: normal;

    &::before {
      margin-left: -10px;
      margin-right: 5px;
      content: '\\2022 ';
    }
  }
`

const Heading = styled.p`
  && {
    line-height: normal;
  }
`

const Price = styled.h4`
  && {
    margin-bottom: 0;
  }
`

const SpansContainer = styled.p`
  && {
    line-height: normal;
  }
`
const Saving = styled.span`
  color: ${(props) => props.theme.color.palette.red};
`

const WasPrice = styled.span`
  display: inline-block;
  margin-left: 5px;
  color: ${(props) => props.theme.color.monochrome.dark};
  text-decoration: line-through;
`

const BundleSaving = styled.span`
  display: block;
  color: ${(props) => props.theme.color.palette.red};
`
const TextContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media only screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-left: 15px;
  }
`
const Content = styled.div`
  height: 55%;
`
const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  margin-top: auto;

  @media only screen and (max-width: ${(props) => props.theme.size.breakpoint['max-width'].sm}) {
    margin-left: 15px;
  }
`

export {
  Wrapper,
  BadgeContainer,
  BodyCopy,
  Content,
  Heading,
  ImageContainer,
  Price,
  SpansContainer,
  Saving,
  TextContainer,
  WasPrice,
  BundleSaving,
  ButtonContainer
}
